import dateService from '@gem/services/date-service';

import { WsAppApiError, WsAppErrorCode } from 'APP/wsApi/wsAppApi/WsAppApiError';

const WS_REQUEST_ERROR = 'WS_REQUEST_ERROR';

export class WsRequestError extends WsAppApiError {
  public readonly name: string = WS_REQUEST_ERROR;
  public readonly time: number = dateService.now().getTime();
  public readonly response?: any;

  constructor(message: string, response?: any) {
    super(WsAppErrorCode.BadData, message);
    this.response = response;
  }
}
